import { BaseService } from "./base.service";
import { IPurchaseCategory } from "models/PurchaseCategoryModel";

class PurchaseCategoryServiceInternal extends BaseService {
	getPurchaseCategoryList = async (
		isCapexSupportInclude?: boolean
	): Promise<IPurchaseCategory[]> =>
		this.callApi<IPurchaseCategory[]>(
			`PurchaseCategory/GetPurchaseCategoryList`,
			"GET",
			isCapexSupportInclude !== undefined
				? new URLSearchParams({
						isCapexSupportInclude: isCapexSupportInclude.toString(),
				  })
				: undefined
		);
}

export const PurchaseCategoryService = new PurchaseCategoryServiceInternal();
